<template>
  <div v-if="storeDoc.Location" :style="alertStyle" class="alert p-2 mt-2 alert-color" role="alert">
    <div class="text-primary pr-2">{{ $t('message.pickUpFrom') }}</div>
    <div class="row">
      <div class="col-sm-9">
        <p class="mb-1">{{ storeDoc.Name }}</p>
        <p class="mb-1">{{ storeDoc.Location.Address }}</p>
        <p class="mb-1">{{ storeDoc.Location.State }}, {{ storeDoc.Location.Suburb }}</p>
      </div>
      <div class="col-sm-3">
        <img
          alt="view in google map"
          class="google-map-img"
          title="Direction"
          :src="googlemapImg"
          @click="GoGoogleMap"
        />
      </div>
    </div>
  </div>
</template>

<script>
import googlemap from "./../../../../assets/google-maps.png";
import { ReplaceAll } from "../../../../api/helpers/stringHelper";
import { mapGetters } from "vuex";
export default {
  props: {
    storeDoc: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters(["mobileStyles", "desktopStyles"]),
    googlemapImg() {
      return googlemap;
    },
    alertStyle() {
      return this.isMobile()
        ? this.mobileStyles.alertInfoBackGround
        : this.desktopStyles.alertInfoBackGround;
    }
  },
  methods: {
    GoGoogleMap() {
      let address = "restaurants+in+";
      address += this.storeDoc.Location.Address
        ? this.storeDoc.Location.Address + "+"
        : "";
      address += this.storeDoc.Location.State
        ? this.storeDoc.Location.State + "+"
        : "";
      address += this.storeDoc.Name ? this.storeDoc.Name : "";

      window.open(
        "https://www.google.com/maps/search/?api=1&zoom=18&query=" +
          ReplaceAll(address, " ", "+")
      );
    }
  }
};
</script>

